"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocaleCode = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    // locale code like 'en-US', 'es-MX', or null if none is specified.
    localeCode: null,
};
var localeSlice = (0, toolkit_1.createSlice)({
    name: 'locales',
    initialState: initialState,
    reducers: {
        setLocaleCode: function (state, action) {
            state.localeCode = action.payload;
        },
    },
});
exports.setLocaleCode = localeSlice.actions.setLocaleCode;
exports.default = localeSlice.reducer;
